import { PrimaryButton, Stack, Text } from "@fluentui/react";
import "./VotingDetails.css";
import moment from "moment";
import { Participant } from "../../Models/Participant";

type VotingDetailsProps = {
  votingDetails: any;
  setVotingDetails: React.Dispatch<any>;
};

export function VotingDetails({ votingDetails, setVotingDetails }: VotingDetailsProps) {
  return (
    <Stack tokens={{ childrenGap: 20 }} className="detailComponent">
      <Text variant="xLarge" className="votingTitle">
        {votingDetails?.title || "Neues Projekt"}
      </Text>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <Stack className="DetailsCreation">
          <Text variant="large">Erstellt von {votingDetails?.creator}</Text>
          <Text variant="large">
            Erstellt am{" "}
            {votingDetails?.date ? moment(votingDetails.date).format("DD. MMMM YYYY") : ""}
          </Text>
        </Stack>
        <Stack horizontalAlign="center" tokens={{ childrenGap: 20 }} className="ResultContainer">
          <Text variant="xLarge">Ergebnis</Text>
          <Text variant="superLarge" className="DetailResult">
            {votingDetails?.result.toFixed(1)}
          </Text>
        </Stack>
      </Stack>
      <Stack horizontal tokens={{ childrenGap: 50 }} horizontalAlign="start">
        <Stack className="DetailsParticipants">
          <Text variant="medium">Teilnehmer</Text>
          <div className="ParticipantsListContainer">
            {votingDetails?.participants.map((participant: Participant) => (
              <Stack
                horizontal
                horizontalAlign="start"
                className="DetailsDetailsParticipants"
                key={participant.id}
              >
                <Stack horizontalAlign="start" className="DetailParticipantName">
                  <Text variant="medium">{participant.name}</Text>
                </Stack>
                <Stack horizontalAlign="end" className="DetailParticipantVote">
                  <Text variant="medium">
                    Schätzung: {participant.vote === -1 ? "?" : participant.vote}
                  </Text>
                </Stack>
              </Stack>
            ))}
          </div>
        </Stack>
      </Stack>
      <PrimaryButton onClick={() => setVotingDetails(undefined)} text="Details ausblenden" />
    </Stack>
  );
}
